export enum PoleEmploiJobOrigine {
  Un = '1',
  Deux = '2',
  AO = 'AO',
}
